import { mapValues } from 'lodash';

const getBlockName = (blockOrFilename: string) => {
  return blockOrFilename.split('/').pop()!.split('.').shift()!;
};

// Takes a `block` string and an `allStyles` object and iterates
// through all of the values in `allStyles`, adding a `label`
// key to them so emotion labels the classes nicely. If a `label`
// is already specified on a value then it'll take precedence.
const labelStyles = <T extends {}>(block: string, allStyles: T): T => {
  block = getBlockName(block);
  const mapped = mapValues(allStyles, (styles, name) => {
    const label = name === 'root' ? block : `${block}__${name}`;

    if (typeof styles === 'function') {
      return (...args: any[]) => [
        {
          label,
        },
        (styles as Function)(...args),
      ];
    }

    return [
      {
        label,
      },
      styles,
    ];
  });
  return (mapped as unknown) as T;
};

export default labelStyles;
